import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';

import { actionSetLaborTickets } from 'lib/actions';
import { GET_CURRENT_MACHINE_LABOR_TICKET } from 'lib/api/queries';
import { getMachine } from 'lib/selectors/getMachine';
import { getIsMESEnabled } from 'lib/selectors/getIsMESEnabled';
import { getMachineSettings } from 'lib/selectors/getMachineSettings';
import { getLaborTicketWhereForMachine } from 'lib/utils/getLaborTicketWhereForMachine';

const useResyncMachineLaborTickets = () => {
  const dispatch = useDispatch();
  const machineRef = useSelector(getMachine)?.machineRef;
  const isMesEnabled = useSelector(getIsMESEnabled);
  const machineSettings = useSelector(getMachineSettings);
  const laborResourceId = machineSettings?.laborResourceId;
  const [requestCurrentMachineLaborTicket] = useLazyQuery(
    GET_CURRENT_MACHINE_LABOR_TICKET,
    {
      fetchPolicy: 'network-only',
    }
  );

  return useCallback(async () => {
    if (!machineRef) {
      return [];
    }

    const where = getLaborTicketWhereForMachine({
      machineRef,
      isMesEnabled,
      laborResourceId,
    });

    const { data } = await requestCurrentMachineLaborTicket({
      variables: {
        where,
      },
    });
    const laborTickets = data?.erpLaborTickets || [];
    dispatch(actionSetLaborTickets(laborTickets));

    return laborTickets;
  }, [
    dispatch,
    machineRef,
    isMesEnabled,
    laborResourceId,
    requestCurrentMachineLaborTicket,
  ]);
};

export default useResyncMachineLaborTickets;
